// extracted by mini-css-extract-plugin
module.exports = {"navTitle":"NavTitle_navTitle__6_VTo"};